import React, { useState, useEffect } from "react";
import { API_AVAILABLE_PAGE_SIZES, API_DEFAULT_PAGE_SIZE } from "../../const";


/* from https://karthikraja555.medium.com/server-side-pagination-in-react-table-a4311b730d19

Usage: 

--------

import React, { useState, useEffect } from "react";
import { getData, columns, formatRowData } from "./data";
import Table from "../../components/table";
import Pagination from "../../components/pagination";

const HomePage = () => {
  const [pageData, setPageData] = useState({
    rowData: [],
    isLoading: false,
    totalPages: 0,
    totalPassengers: 0,
  });
  const [currentPage, setCurrentPage] = useState(1);
  useEffect(() => {
    setPageData((prevState) => ({
      ...prevState,
      rowData: [],
      isLoading: true,
    }));
    getData(currentPage).then((info) => {
      const { totalPages, totalPassengers, data } = info;
      setPageData({
        isLoading: false,
        rowData: formatRowData(data),
        totalPages,
        totalPassengers: 150,
      });
    });
  }, [currentPage]);
  return (
    <div>
      <p>Total Passengers: {pageData.totalPassengers || "Loading..."}</p>
      <div style={{ height: "600px" }}>
        <Table
          columns={columns}
          data={pageData.rowData}
          isLoading={pageData.isLoading}
        />
      </div>
      <Pagination
        totalRows={pageData.totalPassengers}
        pageChangeHandler={setCurrentPage}
        rowsPerPage={15}
      />
    </div>
  );
};

export default HomePage;

--------

*/
const Pagination = ({ pageChangeHandler, totalRows, currentPage, setCurrentPage }) => {
  const [rowsPerPage, setRowsPerPage] = useState(API_DEFAULT_PAGE_SIZE);
  // Calculating max number of pages
  const noOfPages = Math.ceil(totalRows / rowsPerPage);

  // Creating an array with length equal to no.of pages
  const pagesArr = [...new Array(noOfPages)];

  // Navigation arrows enable/disable state
  const [canGoBack, setCanGoBack] = useState(false);
  const [canGoNext, setCanGoNext] = useState(true);

  // Onclick handlers for the butons
  const onNextPage = () => setCurrentPage(currentPage + 1);
  const onPrevPage = () => setCurrentPage(currentPage - 1);
  const onPageSelect = (pageNo) => setCurrentPage(pageNo);

  // Disable previous and next buttons in the first and last page
  // respectively
  useEffect(() => {
    if (noOfPages === currentPage) {
      setCanGoNext(false);
    } else {
      setCanGoNext(true);
    }
    if (currentPage === 1) {
      setCanGoBack(false);
    } else {
      setCanGoBack(true);
    }
  }, [noOfPages, currentPage]);

  // To set the starting index of the page
  useEffect(() => {
    const skipFactor = (currentPage - 1) * rowsPerPage;
    // Some APIs require skip for paginaiton. If needed use that instead
    // pageChangeHandler(skipFactor);
    pageChangeHandler(currentPage, rowsPerPage);
  }, [currentPage, rowsPerPage]);


  const ELLIPSIS = '…'
  const range = (min, max) => Array.from({ length: max - min + 1 }, (_, i) => min + i);

  const getPages = (number = 1, onEachSide = 2, onEnds = 1) => {
    let pages = []

    if (noOfPages <= 9) {
      return range(1, noOfPages)
    }

    if (number <= 4) {
      pages = range(1, 7).concat(ELLIPSIS, noOfPages)
    } else if (number > 4 && number < (noOfPages - 3)) {
      pages = [1, ELLIPSIS].concat(range(number - onEachSide, number + onEachSide), ELLIPSIS, noOfPages)
    } else {
      pages = [1, ELLIPSIS].concat(range(noOfPages - 6, noOfPages))
    }

    return pages
  }

  let pages = getPages(currentPage, 2, 1)

  const getEntriesTransFormats = (count) => {
    return ngettext(
      '%(count)s entry per page',
      '%(count)s entries per page',
      count
    );
  }

  return (
    <>
      {noOfPages > 1 ? (
        <div className="text-center">
          {totalRows} {gettext("entries")} -
          <select className="select-text" onChange={(e) => setRowsPerPage(e.target.value)} value={rowsPerPage}>
            {API_AVAILABLE_PAGE_SIZES.map((size) =>
              <option key={size} value={size}>
                {interpolate(getEntriesTransFormats(size), { count: size }, true)}
              </option>
            )}
          </select>
          <nav aria-label="..." className="mt-3">
            <ul className="pagination">
              {noOfPages > 9 &&
                <li className={`page-item ${canGoBack ? "" : "disabled"}`}>
                  {canGoBack ?
                    <a href="javascript:void(0)" onClick={() => onPageSelect(currentPage - 1)} className="page-link">&#8249;</a>
                    :
                    <span className="page-link">&#8249;</span>
                  }
                </li>
              }
              {pages.map(p =>
                <li className={`page-item d-flex justify-content-center align-items-center ${p === ELLIPSIS ? "disabled" : ""} ${currentPage === p ? "active" : ""}`}>
                  {p === ELLIPSIS ?
                    <a className="page-link" href="javascript:void(0)" >{p}</a>
                    :
                    <a className="page-link" href="javascript:void(0)" onClick={() => onPageSelect(p)}>
                      {p}
                    </a>
                  }
                </li>
              )}
              {noOfPages > 9 &&
                <li className={`page-item d-flex justify-content-center align-items-center me-0 wider ${canGoNext ? "" : "disabled"}`}>
                  {canGoNext ?
                    <a href="javascript:void(0)" onClick={() => onPageSelect(currentPage + 1)} className="page-link">&#8250;</a>
                    :
                    <span className="page-link">&#8250;</span>
                  }
                </li>
              }
            </ul>
          </nav>

        </div>
      ) : null}
    </>
  );
};

export default Pagination;